<template>
  <div>
    <v-data-table
      :loading="isLoading"
      :headers="headers"
      :items="MACAddresses.data"
      :serverItemsLength="MACAddresses.total"
      :items-per-page="20"
      :options.sync="options"
      no-data-text="Pas de MAC adresse associées."
    >
      <template v-slot:item.clientPortal="{ item }">
        <router-link
          v-if="item.clientPortal != null"
          :to="{
            name: 'portail-details',
            params: { id: item.clientPortal.id },
          }"
          class="table-link"
        >
          {{ item.clientPortal.name }}
        </router-link>
      </template>
      <template v-slot:item.card="{ item }">
        <router-link
          v-if="item.card != null"
          :to="{
            name: 'cartes-details',
            params: { id: item.card.id },
          }"
          class="table-link"
        >
          {{ item.card.id }}
        </router-link>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn small icon @click="openDeleteDialog(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.createdAt="{ item }">
        {{ getInternationalDate(item.createdAt) }}
      </template>
      <template v-slot:item.lastAuthOk="{ item }">
        {{ getInternationalDate(item.lastAuthOk) }}
      </template>
    </v-data-table>
    <DeleteDialog :open.sync="deleteDialog" v-on:delete="triggerRemoveAuthMac">
      <template #title> Suppression du cache de la MAC </template>
      <template v-if="selectedAuthMacToDelete != null">
        Vous êtes sur le point de supprimer du cache l'adresse MAC suivante :

        <span class="font-weight-bold">{{ selectedAuthMacToDelete.mac }}</span>
        <br />
        Client :
        <span
          v-if="selectedAuthMacToDelete.clientPortal != null"
          class="font-weight-bold"
        >
          {{ selectedAuthMacToDelete.clientPortal.description }}
          (ID Passman {{ selectedAuthMacToDelete.clientPortal.passmanId }})
        </span>
        <br />
        Carte :
        <span class="font-weight-bold">{{
          selectedAuthMacToDelete.card.id
        }}</span>
        <br /><br />

        Voulez-vous continuer ?
      </template>
    </DeleteDialog>
  </div>
</template>
<script>
import { date } from "@/composables/date";
import { watch, toRefs, onMounted, ref } from "@vue/composition-api";
import DeleteDialog from "@/components/General/DeleteDialog";
import { useAuthentificationMAC } from "@/composables/authentification_mac";

export default {
  props: {
    filterParams: Object,
  },
  components: { DeleteDialog },

  setup(props) {
    /* Import des API */
    const { getInternationalDate } = date();
    const {
      deleteAuthentificationMAC,
      listAuthentificationMAC,
      MACAddresses,
      macAddressData,
    } = useAuthentificationMAC();

    /* Cycle de vie */
    onMounted(() => {
      listAuthentificationMAC(props.filterParams);
    });

    const selectedAuthMacToDelete = ref(null);

    const openDeleteDialog = function (item) {
      selectedAuthMacToDelete.value = item;
      macAddressData.deleteDialog = true;
    };
    const triggerRemoveAuthMac = function () {
      deleteAuthentificationMAC(
        selectedAuthMacToDelete.value.card.id,
        selectedAuthMacToDelete.value.mac,
        props.filterParams
      );
    };

    /* Watchers */
    watch(
      [() => macAddressData.options, () => props.filterParams],
      (newValues, oldValues) => {
        if (oldValues[0].page !== undefined) {
          listAuthentificationMAC(props.filterParams);
        }
      },
      {
        deep: true,
      }
    );
    const headers = [
      { text: "Adresse MAC", value: "mac" },
      { text: "Date de création", value: "createdAt" },
      { text: "Date dernière connexion OK", value: "lastAuthOk" },
      { text: "Action", value: "actions" },
    ];

    if (props.filterParams.card == null) {
      headers.push({ text: "Portail", value: "clientPortal.passmanId" });
      headers.push({ text: "Carte", value: "card" });
    }

    return {
      selectedAuthMacToDelete,
      openDeleteDialog,
      triggerRemoveAuthMac,
      getInternationalDate,
      ...toRefs(macAddressData),
      MACAddresses,
      deleteAuthentificationMAC,
      headers,
    };
  },
};
</script>
